import React from 'react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import {
  SidebarHeader,
  EventTitle,
  EventDate,
  EventLocation,
  CategoryTags,
  CategoryTag
} from '../styles/EventSidebar.styles';

const EventHeader = ({ event }) => {
  return (
    <SidebarHeader>
      <EventTitle>{event.title}</EventTitle>
      <EventDate>
        <span>📅</span> 
        Dal {format(new Date(event.startDate || event.date), 'dd MMMM yyyy', { locale: it })}
        {event.endDate && (
          <> al {format(new Date(event.endDate), 'dd MMMM yyyy', { locale: it })}</>
        )}
      </EventDate>

      <EventLocation>
        <span>📍</span> {event.location}
        {event.city && `, ${event.city}`}
      </EventLocation>
      
      {event.categories && event.categories.length > 0 && (
        <CategoryTags>
          {event.categories.map(category => (
            <CategoryTag key={category.id}>
              {category.name || category.attributes?.name || category}
            </CategoryTag>
          ))}
        </CategoryTags>
      )}
        </SidebarHeader>
  );
};

export default EventHeader;
